import { useState, useContext, createContext, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export const AuthContext = createContext();
export const useAuth = ()=>{
    return useContext(AuthContext)
}

export const AuthProvider = ({ children })=>{
    const [state, setState] = useState({});
    
    useEffect(()=>{
        return onAuthStateChanged(auth, (currentUser)=>{
            setState(currentUser)
        })
    }, [])
    return(
        <AuthContext.Provider value={state}>
            { children }
        </AuthContext.Provider>
    )
}